import { Component, Input } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';

@Component({
  selector: 'app-user-restrictions',
  templateUrl: './user-restrictions.component.html',
  styleUrls: ['./user-restrictions.component.scss'],
  standalone: false,
})
export class UserRestrictionsComponent {
  @Input()
  filters: UntypedFormArray;

  @Input()
  entity: string;
}
